import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { usePantallas } from '../context/PantallasContext';

// Entrar en el dominio a pelo (en producción, HashRouter sin "#/..." en la URL)
// no aterriza en el login: con sesión va a «Mi área personal» (si el usuario
// tiene jugador vinculado y la pantalla es visible; si no, a gestión si es
// ADMIN/COMITE) y sin sesión a las jornadas públicas. Si el hash ya es "#/"
// se muestra el login con normalidad.
export default function Inicio({ children }) {
  const { usuario, cargando } = useAuth();
  const { cargado, esVisible } = usePantallas();
  const aPelo = process.env.NODE_ENV === 'production' && window.location.hash === '';

  const listo = !cargando && cargado;

  if (!aPelo) return children;
  if (!listo) return null;
  if (usuario?.jugadorId && esVisible('/mi-area-personal')) return <Navigate to="/mi-area-personal" replace />;
  if (usuario && (usuario.rol === 'ADMIN' || usuario.rol === 'COMITE')) return <Navigate to="/privado" replace />;
  return <Navigate to="/jornadas" replace />;
}
